export default __webpack_public_path__ + "static/media/laundry2-after-1440w.8588f8a8.avif";